import { FC, memo } from "react";
import { SwiperSlide } from "swiper/react";
import Card from "@shared/components/card";
import { COURSE_TYPE } from "@types";
import { CARD_VARIANT } from "@shared/components/card/types";
import { homePropsCard } from "@shared/components/card/constants";

interface Props {
  product: any;
  slug: string;
  imageWidth: number;
}

const CourseCardItem: FC<Props> = memo(({ product, slug, imageWidth }) => (
  <SwiperSlide
    className="my-swiper-course-slide pb-1"
    style={{ width: "180px" }}
  >
    <Card
      {...product}
      title={product.title_short || product.title}
      sliderSlug={slug}
      slug={product.slug || ""}
      variant={CARD_VARIANT.GRID}
      isBuy={product.is_buy}
      isFavorite={product.is_favorite}
      watchPercent={product.watchTime_Percent || 0}
      type={product.attribute_type || COURSE_TYPE.COURSE}
      sku={product.sku || ""}
      instructor={product.instructors}
      festival={product.festival_new}
      imageWidth={imageWidth}
      hasCertificate={product.hasCertificate || false}
      inCart={product.in_cart || false}
      {...homePropsCard}
    />
  </SwiperSlide>
));
CourseCardItem.displayName = "CourseCardItem";

export default CourseCardItem;
